import React, { lazy, Suspense } from 'react'

const RefinedSite = lazy(() => import('./components/RefinedSite'))
const PersonalSite = lazy(() => import('./components/PersonalSite'))
const LayoutStudies = lazy(() => import('./components/LayoutStudies'))
const IconStudies = lazy(() => import('./components/IconStudies'))
const PlainSite = lazy(() => import('./components/PlainSite'))

export default function App() {
  const params = new URLSearchParams(window.location.search)
  const concept = params.get('concept')
  const earlierStudy = ['ivory', 'obsidian', 'silver'].includes(concept || '')
  const personal = concept === 'personal'
  const layoutStudy = ['index', 'poster', 'salon', 'grid'].includes(
    params.get('layout') || '',
  )
  return (
    <Suspense fallback={null}>
      {window.location.pathname === '/icon-studies' ? (
        <IconStudies />
      ) : earlierStudy ? (
        <RefinedSite />
      ) : personal ? (
        <PersonalSite />
      ) : layoutStudy ? (
        <LayoutStudies />
      ) : (
        <PlainSite />
      )}
    </Suspense>
  )
}
